import React from 'react';
import ActionItem from './ActionItem';
import '../../../styles/chooseAction.scss'
import { useChanges } from "../../../hooks/useChanges";
import {useAdvanceChanges} from '../../../hooks/useAdvanceChanges'



const ChooseActionTamplate = ({ actionArr, currentAction, setCurrentAction, keyName, advance }) => {
    const { addChangeToStore } = useChanges();
    const { addAdvanceChangeToStore } = useAdvanceChanges();
        
    const handleChange = (current) => {
        if (keyName) {
            advance ? addAdvanceChangeToStore({ key: keyName, value: current }) : addChangeToStore({ key: keyName, value: current })
        }
    }

    return (
        <div className='choose_action_wrap'>
            <div className='choose_action_item_wrap'>
                {actionArr.map((item, idx) => (
                    <ActionItem
                    handleChange={handleChange}
                    currentAction={currentAction}
                    setCurrentAction={setCurrentAction}
                    key={idx}
                    item={item}
                    />
                ))}
            </div>
        </div>
    );
};

export default ChooseActionTamplate;